<template>
  <section :class="['section', 'section--resources', 'child-view']">
    <div class="wrapper">
      <div class="content">
        <ul class="resources-list">
          <li
            class="resources-list-item"
            v-for="(item, index) in resources"
            :key="index"
          >
            <router-link
              class="resources-list-link"
              :to="`/resources/${item.id}`"
            >
              <span class="resources-list-type" v-html="item.resource_type"></span>
              <div class="resources-list-holder">
                <div
                  class="resources-list-visual"
                  :style="{ backgroundImage: `url('${item.preview_image.path}')` }"
                >
                  <SquareDummy />
                </div>
                <span
                  class="resources-list-title"
                  ref="title"
                >
                  {{ item.preview_title }}
                </span>
              </div>
              <div
                class="resources-list-text"
                v-html="item.preview_content"
              ></div>
            </router-link>
          </li>
        </ul>
      </div>
      <Footer />
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import SquareDummy from '@/components/SquareDummy';
import Footer from '@/components/UI/Footer';

import { fitTextToString } from '@/utils/helpers';

export default {
  components: { SquareDummy, Footer },
  computed: {
    ...mapGetters({ resources: 'resource/resources:get' }),
  },
  created() {
    if (this.resources.length < 1) {
      this.fetchResources();
    }
  },
  mounted() {
    window.addEventListener('resize', this.setTitlesSize);
    this.setTitlesSize();
  },
  updated() {
    this.setTitlesSize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setTitlesSize);
  },
  methods: {
    ...mapActions({ fetchResources: 'resource/resources:fetch' }),
    setTitlesSize() {
      const titles = this.$refs.title;
      if (Array.isArray(titles) && titles.length > 0) {
        titles.forEach(fitTextToString);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Resources.vue